"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UINanoProgress;

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Color = require("../core/Color");

var _TwoWayTransition = _interopRequireDefault(require("../transitions/TwoWayTransition"));

var getBoxShadow = function getBoxShadow(boxShadow, radius, color) {
  if (typeof boxShadow === 'string') return boxShadow;
  return boxShadow === true ? "0 0 " + radius + "px " + (0, _Color.rgba)(color, 0.5) : undefined;
};

var NanoProgressTransitionWrapper = (0, _styledComponents.default)(_TwoWayTransition.default.PlainWrapper).withConfig({
  displayName: "UINanoProgress__NanoProgressTransitionWrapper",
  componentId: "sc-1nwr3lo-0"
})(["transition:opacity 200ms ease;opacity:", ";"], function (_ref) {
  var closing = _ref.closing;
  return closing ? 0 : 1;
});

var Bar = _styledComponents.default.div.withConfig({
  displayName: "UINanoProgress__Bar",
  componentId: "sc-1nwr3lo-1"
})(["left:0;position:absolute;top:0;width:100%;z-index:", ";"], _sizes.MERCURY_LAYER);

function UINanoProgress(props) {
  var animateOnComplete = props.animateOnComplete,
      boxShadow = props.boxShadow,
      className = props.className,
      color = props.color,
      height = props.height,
      value = props.value;
  return value >= 0 && _react.default.createElement(_TwoWayTransition.default, {
    duration: 200,
    Wrapper: NanoProgressTransitionWrapper,
    className: className
  }, animateOnComplete && value >= 100 ? null : _react.default.createElement(Bar, {
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": value,
    role: "progressbar",
    style: {
      width: value + "%",
      background: color,
      boxShadow: getBoxShadow(boxShadow, height * 3, color),
      height: height,
      transition: 'all 200ms ease'
    }
  }));
}

UINanoProgress.propTypes = {
  animateOnComplete: _propTypes.default.bool,
  boxShadow: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  color: _propTypes.default.string,
  height: _propTypes.default.number,
  value: _propTypes.default.number
};
UINanoProgress.defaultProps = {
  animateOnComplete: false,
  boxShadow: true,
  color: _colors.SORBET,
  height: 2,
  value: 0
};
UINanoProgress.displayName = 'UINanoProgress';
module.exports = exports.default;